import React from 'react'
import '../About/About.css';
import about1 from "../../img/about3.png";

function About() {
    return (
        <>

            <section className="about-section1 d-flex align-items-center">
                <div className="container text-center text-white">
                    <h1 className="fw-bold">About Us</h1>
                </div>
            </section>

            <section className="about-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7 mb-4 mb-lg-0">
                            <h6 className="text-uppercase fw-bold" style={{color:'#cf6511'}}>About Us</h6>
                            <h2 className="fw-bold mb-3">
                                Catering Since 1998<br />
                                {/* <span class="text-dark">Book Us for your Event</span> */}
                            </h2>
                            <p className="text-muted">At Raju Caterers, we believe every event deserves a memorable culinary experience. With years of expertise and a trusted reputation in the Indian catering industry, we provide more than just food — we deliver an experience that delights your guests and makes your event truly unforgettable.
          </p>
          <p className="text-muted">Guided by the ethos “अतिथि देवो भवः” (Guests are like God), our mission is to serve wholesome, high-quality meals that bring people together and leave lasting impressions.</p>
          <p className="text-muted">Whether it’s a private celebration, corporate gathering, or large-scale social event, our team ensures seamless service, timely execution, and flavors that captivate every palate.</p>
           <p>Our carefully curated menu offers a diverse selection of dishes, blending tradition with innovation. Each recipe is crafted with fresh ingredients, meticulous preparation, and elegant presentation.</p>                
                            {/* <p className="">Our Values Are :</p>
                            <p className="">Highest Quality Ingredients   |   Mind Blowing Presentation   |   Delicious Taste   |   Reasonable Pricing   |   Client Satisfaction   |   Personal Attention</p> */}
                        </div>
                        <div className="col-lg-5 text-center position-relative">
                            <div className="image-wrapper">
                                <img src={about1} alt="About Us" class="img-fluid" />
                                <div className="shape"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2>Our Mission</h2>
                            <p>To make your day memorable. We strive to serve the most delicious food coupled with highest quality services to make sure that you relish every bite of it.</p>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2>Our Vision</h2>
                            <p>We are simple people and so is our vision. We want our each and every client to smile broadly whenever they think of us.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About
